import { ColumnDef } from "@tanstack/react-table"
import React, { ReactNode } from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import { ColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import { BILLING_METHOD, PRODUCT_TYPE } from "../../../../../../state/product/Types"

const renderPrice = (product, billingMethod: BILLING_METHOD) => {
    switch (billingMethod) {
    case BILLING_METHOD.ONE_TIME:
        return <FormattedNumber
            style="currency"
            currency={product.currency}
            value={product.oneTimeMinimumPrice}
        />
    case BILLING_METHOD.MONTHLY:
        return <FormattedMessage
            id="generic-listing.pricing-cell-mapper.monthly-price-label"
            defaultMessage="{price} per month"
            values={{
                price: <FormattedNumber
                    style="currency"
                    currency={product.currency}
                    value={product.monthlyMinimumPrice}
                />
            }}
        />
    case BILLING_METHOD.YEARLY:
        return <FormattedMessage
            id="generic-listing.pricing-cell-mapper.yearly-price-label"
            defaultMessage="{price} per year"
            values={{
                price: <FormattedNumber
                    style="currency"
                    currency={product.currency}
                    value={product.yearlyMinimumPrice}
                />
            }}
        />
    }
}

export default (columnDefinition: ColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const product = info.row.original

        if (product && product.billingMethods) {
            return product.billingMethods.reduce((prices: ReactNode[], billingMethod: BILLING_METHOD) => {
                switch (product.type) {
                case PRODUCT_TYPE.MATRIX_PARENT:
                case PRODUCT_TYPE.ASSEMBLY:
                    return [
                        ...prices,
                        <p key={billingMethod} className="m-0">
                            <FormattedMessage
                                id="generic-listing.pricing-cell-mapper.from-price-label"
                                defaultMessage="from {price}"
                                values={{
                                    "price": renderPrice(product, billingMethod)
                                }}
                            />
                        </p>
                    ]
                default:
                    return [
                        ...prices,
                        <p key={billingMethod} className="m-0">
                            {renderPrice(product, billingMethod)}
                        </p>
                    ]
                }
            }, [])
        } else {
            return columnDefinition.dataAttributes?.defaultValue || "-"
        }
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/PricingCellMapper.tsx